import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-stamp',
  templateUrl: './stamp.component.html',
  styleUrls: ['./stamp.component.css']
})

export class StampComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
